<template>
  <div>
    <b-table
      class="sticky-table-header"
      :data="invoicesPacks"
      hoverable
      @click="showDetails"
    >
      <b-table-column
        field="dateRef"
        :label="$t('invoicesPack.referenceMonth')"
        v-slot="props"
      >
        <span class="adjust-top">
          {{ getDate(props.row.dateRef) }}
        </span>
      </b-table-column>

      <b-table-column
        field="link"
        label="Download"
        v-slot="props"
        :visible="showBuyer"
      >
        <span class="adjust-top">
          <a :href="getLink(props.row)"> {{ getLink(props.row) }}</a>
        </span>
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>
    </b-table>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";

export default {
  mixins: [common, mask],

  props: ["invoicesPacks"],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      isPurchaseDetailVisible: false,
      selectedInvoice: null
    };
  },

  methods: {
    getDate(data) {
      const splited = data.split("-");
      return `${splited[1]}/${splited[0]}`;
    },

    getLink(row) {
      return `${process.env.VUE_APP_NF_LINK}/${row.merchant.toString()}/${
        row.dateRef
      }_${row.merchant.toString()}.zip`;
    }
  },

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>

<style>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
